import { Box, Center, Image, Text, VStack } from '@chakra-ui/react';

import { useGetPublicImage } from '@/client/services/hooks/media/useGetPublicImage';
import { useTranslation } from 'react-i18next';

interface ViewOnDesktopProps {
  show: boolean;
  // The default offsets clear LoggedInLayout's fixed MainNav/SideNav. Layouts
  // that render no nav chrome pass false, or the card sits in a blank gap.
  offsetForNav?: boolean;
}

export default function ViewOnDesktop({ show, offsetForNav = true }: ViewOnDesktopProps) {
  const { t } = useTranslation();
  const { getPublicImage } = useGetPublicImage();
  return (
    <Box
      display={!show ? 'none' : 'flex'}
      backgroundColor="white"
      position="sticky"
      zIndex={900}
      top={offsetForNav ? 50 : 0}
      left={offsetForNav ? { base: 0, lg: 50 } : 0}
      right={0}
      data-testid="view-on-desktop"
    >
      <Center
        minHeight="100vh"
        maxWidth="container.sm"
        margin="0 auto"
        padding={{ base: 12, md: 0 }}
      >
        <VStack spacing={4}>
          <Image src={getPublicImage('continu/app-images/view-on-desktop.png')} />

          <Text>{t('admin.viewOnDesktop')}</Text>
        </VStack>
      </Center>
    </Box>
  );
}
